/**
 * Adeline: open the cart drawer the moment someone presses add to cart.
 *
 * The theme waits for two round trips before it opens the drawer: /cart/add.js
 * (which renders the cart sections server side, ~900ms) and then /cart.js
 * (~200ms). That is over a second of nothing happening after the press, which
 * reads as a broken button.
 *
 * So we open the drawer on the click itself, in the capture phase, before the
 * theme starts fetching. The theme's own auto-open still runs afterwards and is
 * a no-op because the dialog is already open, and the contents morph in when
 * the response lands.
 *
 * If the cart was empty we hide the "your cart is empty" state behind a
 * skeleton while the first line loads, otherwise the customer would read
 * "empty" for a second right after adding something.
 */

const LOADING_ATTRIBUTE = 'ad-loading';
const SAFETY_TIMEOUT = 8000;

/** @type {number | undefined} */
let safetyTimer;

function clearLoading() {
  clearTimeout(safetyTimer);
  for (const dialog of document.querySelectorAll(`[${LOADING_ATTRIBUTE}]`)) {
    dialog.removeAttribute(LOADING_ATTRIBUTE);
  }
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[ref="addToCartButton"]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    // Quick add can open a variant picker instead of adding straight away, and
    // the cart drawer would cover that modal.
    if (button.classList.contains('quick-add__button')) return;

    // Let the browser show its own "choose an option" message first.
    const form = button.closest('form');
    if (form instanceof HTMLFormElement && !form.checkValidity()) return;

    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') return;

    const dialog = drawer.querySelector('dialog');
    if (!dialog || dialog.open) return;

    if (dialog.classList.contains('cart-drawer--empty')) {
      dialog.setAttribute(LOADING_ATTRIBUTE, '');
      clearTimeout(safetyTimer);
      safetyTimer = setTimeout(clearLoading, SAFETY_TIMEOUT);
    }

    drawer.open();
  },
  { capture: true }
);

document.addEventListener('cart:update', clearLoading);
document.addEventListener('cart:error', clearLoading);
